'use client';
import React from 'react';
import Link from 'next/link';
import { Plus, Package, ShoppingBag, ShoppingCart } from 'lucide-react';

const actions = [
  {
    id: 'qa-new-product',
    label: 'Nuevo producto',
    icon: <Package size={18} />,
    href: '/productos',
    color: 'bg-secondary text-primary hover:bg-primary hover:text-primary-foreground',
  },
  {
    id: 'qa-add-ingredient',
    label: 'Agregar ingrediente',
    icon: <Plus size={18} />,
    href: '/inventario',
    color: 'bg-pink-50 text-accent hover:bg-accent hover:text-accent-foreground',
  },
  {
    id: 'qa-register-purchase',
    label: 'Registrar compra',
    icon: <ShoppingBag size={18} />,
    href: '/compras',
    color: 'bg-[var(--status-yellow-bg)] text-[var(--status-yellow)] hover:bg-[var(--status-yellow)] hover:text-white',
  },
  {
    id: 'qa-new-sale',
    label: 'Nueva venta',
    icon: <ShoppingCart size={18} />,
    href: '/ventas-punto-de-venta',
    color: 'bg-[var(--status-green-bg)] text-[var(--status-green)] hover:bg-[var(--status-green)] hover:text-white',
  },
];

export default function QuickActions() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {actions?.map((action) => (
        <Link
          key={action?.id}
          href={action?.href}
          className={`flex flex-col items-center gap-2 p-4 rounded-2xl font-600 text-sm text-center transition-all duration-150 border border-border ${action?.color}`}
        >
          <span className="w-9 h-9 rounded-xl bg-white/40 flex items-center justify-center">
            {action?.icon}
          </span>
          {action?.label}
        </Link>
      ))}
    </div>
  );
}